export default __webpack_public_path__ + "static/social-climate-changed-758c85e85db1c0c1437a9853223ab7c7.jpg";